export const COUNSELOR_PRESENCE_REFETCH_INTERVAL_MS = 300_000;
